import axios from 'axios';

// Config
import constants from '../config/constants';

export const confirmPayment = (data) => axios.post(constants.confirmPaymentUrl, data);
export const registerKeepAlive = (data) => axios.post(constants.registerKeepAliveUrl, data);
export const tokenKeepAlive = (data) => axios.post(constants.tokenKeepAliveUrl, data);
